import AIAvatars from './test-embed/AIAvatars';
import styles from './agent-sections.module.css';

export default function AiModalSection() {
  return (
    <div className={styles.aiModalSection} data-cy='agent3d-pricing'>
      <div className={styles.aiModalSectionTitle}>
        Try it now<span className={styles.aiModalSectionTitleAlpha}>Alpha</span>
      </div>
      <AIAvatars />
    </div>
  );
}
